import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "warning"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "link-group center",
  id: "header-list"
};
const _hoisted_5 = ["aria-current"];
const _hoisted_6 = ["aria-current"];
const _hoisted_7 = ["aria-current"];
const _hoisted_8 = ["aria-current"];
const _hoisted_9 = ["aria-current"];
const _hoisted_10 = ["aria-current"];
const _hoisted_11 = ["aria-current"];
const _hoisted_12 = ["aria-current"];
const _hoisted_13 = {
  class: "ng-binding"
};
const _hoisted_14 = ["aria-current"];
const _hoisted_15 = {
  key: 2,
  class: "clerk-ai-btn",
  "data-nav-fixed": ""
};
const _hoisted_16 = {
  class: "link-group right"
};
const _hoisted_17 = ["aria-current"];
const _hoisted_18 = ["title"];
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: "absolute right-0 bottom-[2px] z-[1001] pr-1"
};
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import TrialSummaryMessage from '@/modules/onboarding/components/TrialSummaryMessage.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import RouteService from '@/services/RouteService';
import AccountSwitcherService from '@/services/accountSwitcherService';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useSnackbarStore } from '@/services/snackbarStore';
import LlMenu from '@/components/LlMenu.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import ClerkAiPanel from '@/components/ClerkAiPanel.vue';
import { useClerkAiStore } from '@/stores/insights/useClerkAiStore';
import CompanyContextMismatchModal from '@/components/modals/CompanyContextMismatchModal.vue';
import { useSupportChat } from '@/composables/useSupportChat';
import { useOverflowNav } from '@/composables/useOverflowNav';

// Company context mismatch modal state.
// companyContextModal.js (Angular fallback) defers to this handler when active.

export default {
  __name: 'HeaderComponent',
  props: {
    tracking: {
      type: Object,
      required: false
    },
    leanLawAuth: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: false
    },
    version: {
      type: [String, Array],
      required: false
    },
    timerManager: {
      type: Object,
      required: false
    },
    http: {
      type: Object,
      required: false
    },
    onboardService: {
      type: Object,
      required: false
    },
    userService: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const showMismatchModal = ref(false);
    let _mismatchListener = null;
    onMounted(() => {
      window.__companyContextModalActive = true;
      _mismatchListener = () => {
        showMismatchModal.value = true;
      };
      window.addEventListener('companyContextMismatch', _mismatchListener);
    });
    onBeforeUnmount(() => {
      window.__companyContextModalActive = false;
      if (_mismatchListener) {
        window.removeEventListener('companyContextMismatch', _mismatchListener);
        _mismatchListener = null;
      }
      shutdownChatWidget();
    });

    // Overflow nav - progressive hiding of low-priority items
    const primaryRef = ref(null);
    const {
      hiddenItems,
      isCompact
    } = useOverflowNav(primaryRef, {
      overflowOrder: ['overview', 'calendar', 'fixedFees', 'reports', 'clients', 'expenses', 'matters', 'billing', 'timeEntries']
    });

    // Initialize Pinia stores
    const meStore = useMeStore();
    const accountsStore = useAccountsStore();
    const snackbarStore = useSnackbarStore();
    const {
      getMe
    } = meStore;
    const {
      features,
      me,
      permissions,
      settings,
      terms,
      company
    } = storeToRefs(meStore);
    const {
      accounts
    } = storeToRefs(accountsStore);

    // Support chat composable (HubSpot)
    const {
      getSupportUrl,
      openChat,
      loadChatWidget,
      shutdownChatWidget
    } = useSupportChat();

    // Define props for services from Angular
    const props = __props;

    // Extract services from props
    const {
      tracking,
      leanLawAuth,
      onboardService,
      userService,
      state,
      version,
      timerManager,
      http
    } = props;
    const routeService = new RouteService({
      state: state
    });

    // Reactive current route state
    const currentRouteName = ref('');

    // Watch for route changes and update our reactive state
    if (state) {
      // Set initial route
      currentRouteName.value = state.current?.name || '';

      // For UI-Router, we need to listen on $rootScope for state change events
      // Since we're in Vue, we'll create a simple polling mechanism as a fallback
      let lastRouteName = currentRouteName.value;
      const checkRouteChange = () => {
        if (state && state.current && state.current.name !== lastRouteName) {
          lastRouteName = state.current.name;
          currentRouteName.value = state.current.name;
        }
      };

      // Check for route changes every 100ms
      const routeWatcher = setInterval(checkRouteChange, 100);

      // Note: In a real Vue app we'd use onUnmounted to clear the interval
      // For now, we'll let it run since this component persists
    }

    // User data and trial message
    const msg = ref(null);

    // Initialize store with user data
    const initializeUserData = async () => {
      try {
        await getMe();

        // Load accounts for firm switching dropdown
        await accountsStore.listMyAccounts(true);

        // Now update me.label like Angular UserService does after getting accounts
        if (me.value) {
          const accountsList = Object.values(accounts.value || {}).length > 0 ? Object.values(accounts.value) : me.value?.accounts || [];

          // Replicate Angular UserService label logic
          me.value.label = me.value.first;
          if (accountsList.length > 1) {
            me.value.label = me.value.company?.name || '';
            if (me.value.label.length > 15) {
              me.value.label = `${me.value.label.substring(0, 13)}...`;
            }
          }
        }

        // Load trial message from onboardService like the original Angular directive
        if (onboardService) {
          try {
            const message = await onboardService.message();
            msg.value = message;
          } catch (error) {
            // Silently handle error
          }
        }

        // Initialise the support chat widget after user data is available
        // so the SDK has identity info.
        loadChatWidget();
      } catch (error) {
        // Silently handle error
      }
    };

    // Call initialization when component mounts
    initializeUserData();

    // Watch for changes in me data
    watch(() => me.value, newMe => {
      // Watch for me data changes
    }, {
      deep: true
    });

    // Computed properties for route checking
    const isInvoicesActive = computed(() => {
      const result = currentRouteName.value && currentRouteName.value.startsWith('invoices');
      return result;
    });
    const isMattersActive = computed(() => {
      const result = currentRouteName.value && (currentRouteName.value.startsWith('matters') || currentRouteName.value === 'matters-next');
      return result;
    });
    const isTimeEntriesActive = computed(() => {
      const result = currentRouteName.value && (currentRouteName.value.startsWith('timeentries') || currentRouteName.value.startsWith('time.') || currentRouteName.value === 'time' || currentRouteName.value.includes('timeentry') || currentRouteName.value.includes('timeentries'));
      return result;
    });
    const isTimePlannerActive = computed(() => {
      const result = currentRouteName.value && (currentRouteName.value.startsWith('timeplanner') || currentRouteName.value.startsWith('calendar'));
      return result;
    });
    const isReportsActive = computed(() => {
      const result = currentRouteName.value && currentRouteName.value.startsWith('reports');
      return result;
    });
    const isClientsActive = computed(() => {
      const result = currentRouteName.value && currentRouteName.value.startsWith('clients');
      return result;
    });
    const isBillingActive = computed(() => {
      const result = currentRouteName.value && currentRouteName.value.startsWith('billing') && currentRouteName.value !== 'fixedfees';
      return result;
    });
    const isFixedFeesActive = computed(() => {
      const result = currentRouteName.value && currentRouteName.value === 'fixedfees';
      return result;
    });
    const isExpensesActive = computed(() => {
      const result = currentRouteName.value && currentRouteName.value.startsWith('expenses');
      return result;
    });
    const isSettingsActive = computed(() => {
      const result = currentRouteName.value && currentRouteName.value.startsWith('settings');
      return result;
    });
    const isDashboardActive = computed(() => {
      const result = currentRouteName.value && currentRouteName.value.startsWith('dashboard');
      return result;
    });

    // Development and admin checks
    const isDev = computed(() => {
      return version && isNaN(version[0]);
    });
    const tracker = computed(() => {
      return leanLawAuth ? `${leanLawAuth.domain}/tools/tracker` : '';
    });
    const isAdmin = computed(() => {
      return me.value?.company?.domainKey === 'leanlaw' && me.value?.access?.setup;
    });
    const showReports = computed(() => {
      return permissions.value?.reports?.view || permissions.value?.reports?.billable || permissions.value?.reports?.revenue || permissions.value?.reports?.revenueAttorney || permissions.value?.reports?.myrevenue;
    });
    const showFixedFees = computed(() => {
      return permissions.value?.charges?.create && features.value?.centralizedFixedFeePage;
    });
    const canUseChat = computed(() => !!me.value?.permissions?.reports?.chat);
    const showChat = computed(() => features.value?.dashboard && canUseChat.value);
    const showDashboards = computed(() => {
      return features.value?.dashboard && me.value?.permissions.reports.viewDashboards;
    });

    // Check if the firm is in trial status for M365 feature flipper auto-enable
    const isFirmInTrial = computed(() => {
      return me.value?.company?.subscription?.trial || false;
    });

    // Dynamic header styles to handle impersonation banner
    const headerStyles = computed(() => {
      // For testing: always apply the styles when warning banner is shown
      // Change this back to `me.value?.impersonation` when testing is done
      if (me?.value?.impersonation) {
        // This matches the v-if="true" condition in the template
        return {
          position: 'relative',
          top: '0px',
          // Position 30px from top to sit right below the 30px warning banner
          left: '0px',
          right: '0px',
          marginTop: '0px',
          zIndex: '999'
        };
      }
      return {};
    });

    // Watch for impersonation changes and update body class
    watch(() => me.value?.impersonation, isImpersonating => {
      if (typeof document !== 'undefined') {
        if (isImpersonating) {
          document.body.classList.add('has-impersonation');
        } else {
          document.body.classList.remove('has-impersonation');
        }
      }
    }, {
      immediate: true
    });

    // User display name
    const userDisplayName = computed(() => {
      if (!me.value) return '';

      // For user display, use first/last name or email, not company name
      if (me.value.first && me.value.last) {
        return `${me.value.first} ${me.value.last}`;
      } else if (me.value.first) {
        return me.value.first;
      } else if (me.value.email) {
        return me.value.email;
      }
      return 'User';
    });

    // User accounts for account switching
    const userAccounts = computed(() => {
      // In Vue, we fetch accounts from accountsStore, fallback to me.accounts if store is empty
      const storeAccounts = accounts.value || {};
      const meAccounts = me.value?.accounts || [];
      const accountsList = Object.values(storeAccounts).length > 0 ? Object.values(storeAccounts) : meAccounts;
      return accountsList;
    });

    // Firm name (company name) - replicate exact Angular UserService label logic
    const firmName = computed(() => {
      if (!me.value) return '';

      // Get accounts list to check if we have multiple accounts
      const accountsList = userAccounts.value || [];

      // If we have company info and no accounts loaded yet, prioritize company name
      // This prevents flashing the user's first name during firm switching
      if (me.value.company?.name && accountsList.length === 0) {
        let label = me.value.company.name;
        if (label.length > 15) {
          label = `${label.substring(0, 13)}...`;
        }
        return label;
      }

      // Replicate the exact Angular UserService logic for user.label
      let label = me.value.first || '';
      if (accountsList.length > 1) {
        // User label is shown in header and we modify it to the firm
        // name if we have multiple accounts
        label = me.value.company?.name || '';
        if (label.length > 15) {
          label = `${label.substring(0, 13)}...`;
        }
      }
      return label;
    });
    const clerkAi = useClerkAiStore();
    const toggleChat = () => clerkAi.toggle();

    // User menu items
    const userMenuItems = computed(() => {
      const items = [];

      // Add firm switching options if multiple accounts
      if (userAccounts.value.length > 1) {
        userAccounts.value.forEach(account => {
          items.push({
            id: `account-${account.id}`,
            title: account.company.name,
            icon: me.value?.id === account.id ? 'fa fa-check' : 'fa fa-sign-in',
            disabled: me.value?.id === account.id,
            action: () => change(account)
          });
        });

        // Add separator
        items.push({
          divider: true
        });
      }

      // Sign Out
      items.push({
        id: 'logout',
        title: 'Sign Out',
        icon: 'fa fa-sign-out',
        action: logOut
      });

      // Admin option
      if (isAdmin.value) {
        items.push({
          id: 'admin',
          title: 'Admin',
          icon: 'fa fa-bolt',
          action: goAdmin
        });
      }
      return items;
    });

    // Support menu items
    const supportMenuItems = computed(() => [{
      id: 'get-started',
      title: 'Get Started',
      icon: 'fa fa-certificate',
      action: () => support('gettingStarted')
    }, {
      id: 'report-bug',
      title: 'Report Bug',
      icon: 'fa fa-dot-circle-o',
      action: reportBug
    }, {
      id: 'documentation',
      title: 'Documentation',
      icon: 'fa fa-bookmark',
      action: () => support()
    }, {
      id: 'live-support',
      title: 'Live Support',
      icon: 'fa fa-comments',
      action: openChat
    }]);

    // Overflow "More" menu items
    const overflowMenuItems = computed(() => {
      const items = [];
      const mattersLabel = `${terms.value?.Matter || 'Matter'}s`;
      const itemDefs = [{
        id: 'overview',
        title: 'Overview',
        action: goToDashboard,
        visible: showDashboards.value
      }, {
        id: 'calendar',
        title: 'Calendar',
        action: goToTimePlanner,
        visible: true
      }, {
        id: 'timeEntries',
        title: 'Time Entries',
        action: goToTimeEntries,
        visible: true
      }, {
        id: 'expenses',
        title: 'Expenses',
        action: goToExpenses,
        visible: permissions.value?.expenses?.view
      }, {
        id: 'fixedFees',
        title: 'Fixed Fees',
        action: goToFixedFees,
        visible: showFixedFees.value
      }, {
        id: 'billing',
        title: 'Billing',
        action: goToBilling,
        visible: permissions.value?.billing?.view
      }, {
        id: 'clients',
        title: 'Clients',
        action: goToClients,
        visible: permissions.value?.matters?.create
      }, {
        id: 'matters',
        title: mattersLabel,
        action: goToMatters,
        visible: permissions.value?.matters?.create
      }, {
        id: 'reports',
        title: 'Reports',
        action: goToReports,
        visible: showReports.value
      }];
      for (const def of itemDefs) {
        if (hiddenItems.value.has(def.id) && def.visible) {
          items.push({
            id: def.id,
            title: def.title,
            action: def.action
          });
        }
      }
      return items;
    });

    // Quick create menu items
    const quickCreateMenuItems = computed(() => {
      const items = [];

      // Add Client
      if (permissions.value?.matters?.create) {
        items.push({
          id: 'add-client',
          title: 'Add Client',
          icon: 'fa fa-address-book',
          action: goToCreateClient
        });
      }

      // Add Matter
      if (permissions.value?.matters?.create) {
        items.push({
          id: 'add-matter',
          title: `Add ${terms.value?.Matter || 'Matter'}`,
          icon: 'fa fa-folder',
          action: goToCreateMatter
        });
      }

      // New Time Entry
      items.push({
        id: 'new-time-entry',
        title: 'New Time Entry',
        icon: 'fa fa-calendar-o',
        action: goToCreateTimeEntry
      });

      // New Expense
      if (permissions.value?.expenses?.create) {
        items.push({
          id: 'new-expense',
          title: 'New Expense',
          icon: 'fa fa-usd',
          action: goToNewExpense
        });
      }

      // Fixed Fee
      if (permissions.value?.charges?.create) {
        items.push({
          id: 'fixed-fee',
          title: 'Fixed Fee',
          icon: 'fa fa-usd',
          action: goToCreateCharge
        });
      }

      // Start Timer
      items.push({
        id: 'start-timer',
        title: 'Start Timer',
        icon: 'fa fa-clock-o',
        action: startTimer
      });

      // Deposit to Trust
      if (permissions.value?.trust?.deposit && company.value?.settings?.trust?.accounts?.length) {
        items.push({
          id: 'deposit-trust',
          title: 'Deposit to Trust',
          icon: 'fa fa-bank',
          action: deposit
        });
      }

      // Trust Request
      if (permissions.value?.trust?.deposit && company.value?.settings?.gravity?.enabled) {
        items.push({
          id: 'trust-request',
          title: 'Trust Request',
          icon: 'fa fa-bank',
          action: request
        });
      }
      return items;
    });

    // Methods
    const goToReports = () => {
      routeService.go('reports.dashboard');
    };
    const goToMatters = () => {
      // Feature-flagged route (sc-46278): send accounts with fizzyLiftingDrink
      // enabled to the rewritten /matters page; everyone else keeps the current
      // /matters-next experience. Mirrors the guard in MattersPage.vue, which
      // would otherwise just bounce them back here anyway.
      if (features.value?.fizzyLiftingDrink) {
        routeService.go('matters');
        return;
      }
      routeService.go('matters-next');
    };
    const goToClients = () => {
      // Same flag as goToMatters; ClientsPage.vue also redirects accounts without it.
      routeService.go(features.value?.fizzyLiftingDrink ? 'clients2' : 'clients');
    };
    const goToBilling = () => {
      routeService.go('billing');
    };
    const goToFixedFees = () => {
      routeService.go('fixedfees');
    };
    const goToExpenses = () => {
      routeService.go('expenses');
    };
    const goToSettings = () => {
      routeService.go('settings');
    };
    const goToTimeEntries = () => {
      routeService.go('timeentries');
    };
    const goToTimePlanner = () => {
      routeService.go('timeplanner');
    };
    const goToDashboard = () => {
      routeService.go('dashboard');
    };
    const goToCreateClient = () => {
      if (me.value) {
        // Use the same conditional logic as in original Angular component
        const route1 = 'clients.newMatter.client';
        const route2 = 'clients.client2';

        // Check if we should use the newer route
        // Trial firms automatically get the new experience
        const enableNewTimeEntry = isFirmInTrial.value || (features.value?.timeEntriesTab ?? false) && (settings.value?.enableNewTimeEntry ?? false);
        const route = enableNewTimeEntry ? route2 : route1;

        // Pass methodOverride as a state parameter so it's accessible in stateParams
        routeService.go(route, {
          methodOverride: 'plus sign'
        });
      }
    };
    const goToCreateMatter = () => {
      if (me.value) {
        // Use the same conditional logic as in original Angular component
        const route1 = 'matters-next.newMatter';
        const route2 = 'matters-next.matter2';

        // Check if we should use the newer route (same logic as createClient)
        // Trial firms automatically get the new experience
        const enableNewTimeEntry = isFirmInTrial.value || (features.value?.timeEntriesTab ?? false) && (settings.value?.enableNewTimeEntry ?? false);
        const route = enableNewTimeEntry ? route2 : route1;

        // Pass methodOverride as a state parameter so it's accessible in stateParams
        routeService.go(route, {
          methodOverride: 'plus sign'
        });
      }
    };
    const goToCreateTimeEntry = () => {
      if (me.value) {
        // Trial firms automatically get the new experience
        const enableNewTimeEntry = isFirmInTrial.value || (features.value?.timeEntriesTab ?? false) && (settings.value?.enableNewTimeEntry ?? false);
        if (enableNewTimeEntry) {
          // Use the new Vue modal for time entry
          routeService.go('timeplanner.new2', {
            entry: {
              account: null // This would be $scope.$parent.plannerAccount in Angular
            }
          });
        } else {
          routeService.go('timeplanner.new');
        }
      }
    };
    const goToNewExpense = () => {
      // Pass methodOverride as a state parameter so it's accessible in stateParams
      routeService.go('expenses.list.new', {
        methodOverride: 'plus sign'
      });
    };
    const goToCreateCharge = () => {
      if (me.value) {
        // Check if we're on the fixed fees page with centralized feature flag
        if (currentRouteName.value?.startsWith('fixedfees') && features.value?.centralizedFixedFeePage) {
          // Clear any existing panel params and set modal=create for clean URL
          routeService.go('fixedfees', {
            modal: 'create',
            chargeId: undefined,
            panel: undefined,
            matterId: undefined
          });
          return;
        }

        // Pass methodOverride as a state parameter so it's accessible in stateParams
        routeService.go('matters-next.charge', {
          methodOverride: 'plus sign',
          entryPoint: 'quick_create'
        });
      }
    };
    const startTimer = () => {
      if (timerManager) {
        try {
          timerManager.createTimer({
            start: true
          });
          routeService.go('timeplanner');
        } catch (error) {
          // Handle error silently
        }
      }
    };
    const deposit = () => {
      routeService.go('billing.trust.summary.deposit', {
        clientId: null,
        matterId: null,
        client: null,
        matter: null,
        trust: null
      });
    };
    const request = () => {
      routeService.go('billing.trust.summary.request');
    };
    const logOut = () => {
      // Shut down chat widget before redirect so HubSpot cookies
      // and tracking state are cleaned up for the next user session.
      shutdownChatWidget();

      // Clear localstorage so data doesn't bleed across accounts
      window.localStorage.clear();
      window.sessionStorage.clear();
      if (leanLawAuth) {
        leanLawAuth.logoff('header');
      }
    };
    const goAdmin = () => {
      if (!leanLawAuth || !leanLawAuth.domain) {
        // This is for 'current' environment

        window.location.href = '/admin';
        return;
      }
      let adminLink = leanLawAuth.domain.replace(/api/, 'admin').replace(/next-be/, 'admin').replace(/localhost:\d+/, 'localhost:8088');
      if (adminLink.indexOf('#') > 0) {
        adminLink = adminLink.substring(0, adminLink.indexOf('#'));
      }
      window.location.href = adminLink;
    };
    const support = articleKey => {
      if (tracking) {
        tracking.event('Open Support');
      }
      const url = getSupportUrl(articleKey || 'documentation');
      if (window) {
        window.open(url, '_blank');
      }
    };
    const reportBug = () => {
      openChat();
    };
    const changeAccount = account => {
      if (leanLawAuth && http) {
        const redirect = `${window.location.origin}${window.location.pathname}#/`;
        const accountSwitcherService = new AccountSwitcherService(leanLawAuth, http);
        accountSwitcherService.switchFirm(account, redirect);
      }
    };
    const change = account => {
      changeAccount(account);
    };
    const stopImpersonating = () => {
      if (leanLawAuth) {
        window.location.href = `${leanLawAuth.domain}/account/impersonate`;
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(me)?.impersonation ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createTextVNode(" Impersonating " + _toDisplayString(_unref(me).first) + " " + _toDisplayString(_unref(me).last) + "! ", 1), _createElementVNode("span", {
        onClick: stopImpersonating,
        style: {
          "float": "right"
        }
      }, "Sign Out")])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["header no-print", {
          'has-warning': _unref(me)?.impersonation
        }]),
        style: _normalizeStyle(headerStyles.value)
      }, [showChat.value || showDashboards.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        class: "logo",
        src: "/img/LeanLaw_Logo_Circle_2022.svg",
        alt: "LeanLaw Logo",
        "ui-sref": "timeplanner",
        onClick: goToTimePlanner,
        style: {
          "cursor": "pointer"
        }
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
        class: "logo",
        src: "/img/LeanLaw_Logo_Color_2022.svg",
        alt: "LeanLaw Logo",
        "ui-sref": "timeplanner",
        onClick: goToTimePlanner,
        style: {
          "cursor": "pointer"
        }
      }), _createElementVNode("img", {
        class: "logo-circle",
        src: "/img/LeanLaw_Logo_Circle_2022.svg",
        alt: "LeanLaw Logo",
        "ui-sref": "timeplanner",
        onClick: goToTimePlanner,
        style: {
          "cursor": "pointer"
        }
      })])), _createElementVNode("div", {
        class: "primary",
        ref_key: "primaryRef",
        ref: primaryRef
      }, [_createElementVNode("div", _hoisted_4, [_unref(hiddenItems).size > 0 ? (_openBlock(), _createBlock(LlMenu, {
        key: 0,
        items: overflowMenuItems.value,
        location: "bottom start",
        "close-on-content-click": true,
        "open-on-hover": true,
        "z-index": 3000
      }, {
        activator: _withCtx(({
          props: menuProps,
          isOpen
        }) => [_createElementVNode("a", _mergeProps({
          href: "#",
          class: "more-menu-link"
        }, menuProps, {
          class: {
            'menu-open': isOpen
          },
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }), [...(_cache[5] || (_cache[5] = [_createElementVNode("span", null, "More", -1), _createElementVNode("i", {
          class: "fa fa-chevron-down"
        }, null, -1)]))], 16)]),
        _: 1
      }, 8, ["items"])) : _createCommentVNode("", true), showDashboards.value ? _withDirectives((_openBlock(), _createElementBlock("a", {
        key: 1,
        href: "#/dashboard",
        "ui-sref": "dashboard",
        "data-nav-id": "overview",
        onClick: _withModifiers(goToDashboard, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isDashboardActive.value,
          'll-nav-current-x': isDashboardActive.value
        }]),
        "aria-current": isDashboardActive.value ? 'page' : undefined
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", {
        class: "ng-binding"
      }, "Overview", -1)]))], 10, _hoisted_5)), [[_vShow, !_unref(hiddenItems).has('overview')]]) : _createCommentVNode("", true), _withDirectives(_createElementVNode("a", {
        href: "#/timeplanner",
        "ui-sref": "timeplanner",
        "data-nav-id": "calendar",
        onClick: _withModifiers(goToTimePlanner, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isTimePlannerActive.value,
          'll-nav-current-x': isTimePlannerActive.value
        }]),
        "aria-current": isTimePlannerActive.value ? 'page' : undefined
      }, [...(_cache[7] || (_cache[7] = [_createElementVNode("span", {
        class: "ng-binding"
      }, "Calendar", -1)]))], 10, _hoisted_6), [[_vShow, !_unref(hiddenItems).has('calendar')]]), _withDirectives(_createElementVNode("a", {
        href: "#/timeentries",
        "ui-sref": "timeentries",
        "data-nav-id": "timeEntries",
        onClick: _withModifiers(goToTimeEntries, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isTimeEntriesActive.value,
          'll-nav-current-x': isTimeEntriesActive.value
        }]),
        "aria-current": isTimeEntriesActive.value ? 'page' : undefined
      }, [...(_cache[8] || (_cache[8] = [_createElementVNode("span", {
        class: "ng-binding"
      }, "Time Entries", -1)]))], 10, _hoisted_7), [[_vShow, !_unref(hiddenItems).has('timeEntries')]]), _withDirectives(_createElementVNode("a", {
        href: "#/expenses",
        "ui-sref": "expenses",
        "data-nav-id": "expenses",
        onClick: _withModifiers(goToExpenses, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isExpensesActive.value,
          'll-nav-current-x': isExpensesActive.value
        }]),
        "aria-current": isExpensesActive.value ? 'page' : undefined
      }, [...(_cache[9] || (_cache[9] = [_createElementVNode("span", {
        class: "ng-binding"
      }, "Expenses", -1)]))], 10, _hoisted_8), [[_vShow, _unref(permissions)?.expenses?.view && !_unref(hiddenItems).has('expenses')]]), _withDirectives(_createElementVNode("a", {
        href: "#/fixedfees",
        "ui-sref": "fixedfees",
        "data-nav-id": "fixedFees",
        onClick: _withModifiers(goToFixedFees, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isFixedFeesActive.value,
          'll-nav-current-x': isFixedFeesActive.value
        }]),
        "aria-current": isFixedFeesActive.value ? 'page' : undefined
      }, [...(_cache[10] || (_cache[10] = [_createElementVNode("span", {
        class: "ng-binding"
      }, "Fixed Fees", -1)]))], 10, _hoisted_9), [[_vShow, showFixedFees.value && !_unref(hiddenItems).has('fixedFees')]]), _withDirectives(_createElementVNode("a", {
        href: "#/billing",
        "ui-sref": "billing",
        "data-nav-id": "billing",
        onClick: _withModifiers(goToBilling, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isBillingActive.value,
          'll-nav-current-x': isBillingActive.value
        }]),
        "aria-current": isBillingActive.value ? 'page' : undefined
      }, [...(_cache[11] || (_cache[11] = [_createElementVNode("span", {
        class: "ng-binding"
      }, "Billing", -1)]))], 10, _hoisted_10), [[_vShow, _unref(permissions)?.billing?.view && !_unref(hiddenItems).has('billing')]]), _withDirectives(_createElementVNode("a", {
        href: "#/clients",
        "ui-sref": "clients",
        "data-nav-id": "clients",
        onClick: _withModifiers(goToClients, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isClientsActive.value,
          'll-nav-current-x': isClientsActive.value
        }]),
        "aria-current": isClientsActive.value ? 'page' : undefined
      }, [...(_cache[12] || (_cache[12] = [_createElementVNode("span", {
        class: "ng-binding"
      }, "Clients", -1)]))], 10, _hoisted_11), [[_vShow, _unref(permissions)?.matters?.create && !_unref(hiddenItems).has('clients')]]), _withDirectives(_createElementVNode("a", {
        href: "#/matters-next",
        "ui-sref": "matters-next",
        "data-nav-id": "matters",
        onClick: _withModifiers(goToMatters, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isMattersActive.value,
          'll-nav-current-x': isMattersActive.value
        }]),
        "aria-current": isMattersActive.value ? 'page' : undefined,
        "data-cy": "header-matters"
      }, [_createElementVNode("span", _hoisted_13, _toDisplayString(_unref(terms)?.Matter || 'Matter') + "s", 1)], 10, _hoisted_12), [[_vShow, _unref(permissions)?.matters?.create && !_unref(hiddenItems).has('matters')]]), _withDirectives(_createElementVNode("a", {
        href: "#/reports/dashboard",
        "ui-sref": "reports.dashboard",
        "data-nav-id": "reports",
        onClick: _withModifiers(goToReports, ["prevent"]),
        class: _normalizeClass(['ll-nav-item', {
          active: isReportsActive.value,
          'll-nav-current-x': isReportsActive.value
        }]),
        "aria-current": isReportsActive.value ? 'page' : undefined,
        id: "header-reports"
      }, [...(_cache[13] || (_cache[13] = [_createElementVNode("span", {
        class: "ng-binding"
      }, "Reports", -1)]))], 10, _hoisted_14), [[_vShow, showReports.value && !_unref(hiddenItems).has('reports')]]), showChat.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(LlSecondaryButton, {
        size: "small",
        color: "primary",
        variant: "outlined",
        class: "w-full sm:w-auto",
        "prepend-icon": "mdi-message-question-outline",
        onClick: _cache[1] || (_cache[1] = $event => toggleChat())
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" ClerkAI ", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createVNode(LlMenu, {
        items: quickCreateMenuItems.value,
        location: "bottom end",
        "close-on-content-click": true,
        "open-on-hover": true,
        "z-index": 3000
      }, {
        activator: _withCtx(({
          props: menuProps,
          isOpen
        }) => [_createElementVNode("a", _mergeProps({
          href: "#",
          class: "add-button square-button fa fa-plus",
          title: "Quick create"
        }, menuProps, {
          class: {
            'menu-open': isOpen
          },
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }), null, 16)]),
        _: 1
      }, 8, ["items"]), _createVNode(LlMenu, {
        items: supportMenuItems.value,
        location: "bottom end",
        "close-on-content-click": true,
        "open-on-hover": true,
        "z-index": 3000
      }, {
        activator: _withCtx(({
          props: menuProps,
          isOpen
        }) => [_createElementVNode("a", _mergeProps({
          href: "#",
          class: "square-button fa fa-question",
          title: "Support"
        }, menuProps, {
          class: {
            'menu-open': isOpen
          },
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }), null, 16)]),
        _: 1
      }, 8, ["items"]), _createElementVNode("a", {
        href: "#/settings",
        "ui-sref": "settings",
        class: _normalizeClass(["square-button fa fa-cog", ['ll-nav-item', {
          active: isSettingsActive.value,
          'll-nav-current-x': isSettingsActive.value
        }]]),
        "data-cy": "settings-icon",
        title: "Settings",
        onClick: _withModifiers(goToSettings, ["prevent"]),
        "aria-current": isSettingsActive.value ? 'page' : undefined
      }, null, 10, _hoisted_17), _createVNode(LlMenu, {
        items: userMenuItems.value,
        location: "bottom end",
        "close-on-content-click": true,
        "open-on-hover": true,
        "z-index": 3000,
        class: "p-4"
      }, {
        activator: _withCtx(({
          props: menuProps,
          isOpen
        }) => [_createElementVNode("a", _mergeProps({
          href: "#",
          class: "user-button",
          title: firmName.value || 'Account'
        }, menuProps, {
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
          class: {
            'menu-open': isOpen
          }
        }), [!_unref(isCompact) ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(firmName.value), 1)) : _createCommentVNode("", true), _cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "fa fa-user-circle"
        }, null, -1))], 16, _hoisted_18)]),
        _: 1
      }, 8, ["items"])]), _createElementVNode("div", _hoisted_20, [_createVNode(TrialSummaryMessage, {
        leanLawApi: _unref(leanLawAuth),
        userService: _unref(userService)
      }, null, 8, ["leanLawApi", "userService"])])], 512), _createVNode(SnackbarComponent), canUseChat.value ? (_openBlock(), _createBlock(ClerkAiPanel, {
        key: 2
      })) : _createCommentVNode("", true), _createVNode(CompanyContextMismatchModal, {
        show: showMismatchModal.value
      }, null, 8, ["show"])], 6)], 64);
    };
  }
};